var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "telnyx-balance" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("h3", [_vm._v("Hesap Bakiyesi")]),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: { loading: _vm.loading, type: "primary" },
            on: { click: _vm.loadBalance },
          },
          [
            _c("span", { staticClass: "material-icons" }, [_vm._v("refresh")]),
            _vm._v("\n            Yenile\n        "),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.loading && !_vm.balance
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("a-spin", { attrs: { size: "large" } }),
            _vm._v(" "),
            _c("p", [_vm._v("Bakiye bilgileri yükleniyor...")]),
          ],
          1
        )
      : _vm.error
      ? _c(
          "div",
          { staticClass: "error-container" },
          [
            _c("a-alert", {
              attrs: {
                message: _vm.error,
                type: "error",
                "show-icon": "",
                closable: false,
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "primary" },
                on: { click: _vm.loadBalance },
              },
              [_vm._v("\n            Tekrar Dene\n        ")]
            ),
          ],
          1
        )
      : _vm.balance
      ? _c(
          "div",
          { staticClass: "balance-content" },
          [
            _c(
              "a-row",
              { attrs: { gutter: [24, 24] } },
              [
                _c("a-col", { attrs: { span: 8 } }, [
                  _c(
                    "div",
                    { staticClass: "modern-balance-card main-balance" },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", { staticClass: "card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("account_balance_wallet"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v("Ana Bakiye"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "balance-amount" }, [
                          _c("span", { staticClass: "currency" }, [
                            _vm._v(_vm._s(_vm.balance.data.currency)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              _vm._s(_vm.formatAmount(_vm.balance.data.balance))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress-section" }, [
                          _c("div", { staticClass: "progress-bar" }, [
                            _c("div", {
                              staticClass: "progress-fill",
                              style: { width: _vm.mainBalancePercentage + "%" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "balance-description" }, [
                            _vm._v("Toplam hesap bakiyesi"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-footer" },
                        [
                          _c(
                            "a-tag",
                            {
                              staticClass: "status-tag",
                              attrs: { color: _vm.balanceStatus.color },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.balanceStatus.text) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("a-col", { attrs: { span: 8 } }, [
                  _c(
                    "div",
                    { staticClass: "modern-balance-card pending-balance" },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", { staticClass: "card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("schedule"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v("Bekleyen Tutarlar"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "balance-amount" }, [
                          _c("span", { staticClass: "currency" }, [
                            _vm._v(_vm._s(_vm.balance.data.currency)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              _vm._s(_vm.formatAmount(_vm.balance.data.pending))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress-section" }, [
                          _c("div", { staticClass: "progress-bar" }, [
                            _c("div", {
                              staticClass: "progress-fill pending",
                              style: { width: _vm.pendingPercentage + "%" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "balance-description" }, [
                            _vm._v("İşleme alınan tutarlar"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer" }, [
                        _c("span", { staticClass: "info-text" }, [
                          _vm._v(
                            _vm._s(_vm.pendingPercentage.toFixed(1)) +
                              "% beklemede"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("a-col", { attrs: { span: 8 } }, [
                  _c(
                    "div",
                    { staticClass: "modern-balance-card frozen-balance" },
                    [
                      _c("div", { staticClass: "card-header" }, [
                        _c("div", { staticClass: "card-icon" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("ac_unit"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v("Donmuş Bakiye"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "balance-amount" }, [
                          _c("span", { staticClass: "currency" }, [
                            _vm._v(_vm._s(_vm.balance.data.currency)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              _vm._s(_vm.formatAmount(_vm.balance.data.frozen))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress-section" }, [
                          _c("div", { staticClass: "progress-bar" }, [
                            _c("div", {
                              staticClass: "progress-fill frozen",
                              style: { width: _vm.frozenPercentage + "%" },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "balance-description" }, [
                            _vm._v("Kullanıma kapalı tutar"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer" }, [
                        _c("span", { staticClass: "percentage-text" }, [
                          _vm._v(
                            _vm._s(_vm.frozenPercentage.toFixed(1)) +
                              "% donduruldu"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-row",
              {
                staticStyle: { "margin-top": "32px" },
                attrs: { gutter: [24, 24] },
              },
              [
                _c("a-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "modern-details-card" }, [
                    _c("div", { staticClass: "details-header" }, [
                      _c("div", { staticClass: "details-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("info"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("h3", [_vm._v("Detay Bilgiler")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details-grid" }, [
                      _c("div", { staticClass: "detail-item" }, [
                        _c("div", { staticClass: "detail-label" }, [
                          _vm._v("Hesap Tipi"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-value" }, [
                          _vm._v(_vm._s(_vm.balance.data.record_type)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-item" }, [
                        _c("div", { staticClass: "detail-label" }, [
                          _vm._v("Para Birimi"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "detail-value currency-badge" },
                          [_vm._v(_vm._s(_vm.balance.data.currency))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-item" }, [
                        _c("div", { staticClass: "detail-label" }, [
                          _vm._v("Kullanılabilir Kredi"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-value" }, [
                          _vm._v(
                            _vm._s(_vm.balance.data.currency) +
                              " " +
                              _vm._s(
                                _vm.formatAmount(
                                  _vm.balance.data.available_credit
                                )
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-item" }, [
                        _c("div", { staticClass: "detail-label" }, [
                          _vm._v("Bakiye Durumu"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "detail-value" },
                          [
                            _c(
                              "a-tag",
                              {
                                staticClass: "modern-status-tag",
                                attrs: { color: _vm.balanceStatus.color },
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.balanceStatus.text) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-item" }, [
                        _c("div", { staticClass: "detail-label" }, [
                          _vm._v("Son Güncelleme"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail-value timestamp" }, [
                          _vm._v(_vm._s(_vm.lastUpdated)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.totalBalance < 50
              ? _c(
                  "div",
                  { staticClass: "warning-section" },
                  [
                    _c("a-alert", {
                      attrs: {
                        message: "Düşük Bakiye Uyarısı",
                        description:
                          "Hesap bakiyeniz " +
                          _vm.balance.data.currency +
                          " " +
                          _vm.formatAmount(_vm.balance.data.balance) +
                          " seviyesinde. Lütfen bakiye yüklemesi yapınız.",
                        type: "warning",
                        "show-icon": "",
                        closable: false,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }